export const CurveArrowSVG = ({ className = '' }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 163 103"
    fill="none"
    className={className}
  >
    <path
      stroke="#FFDCD1"
      strokeLinecap="round"
      strokeWidth={4.66}
      d="M2.501 53.661c17.136-13.123 39.683-23.983 61.814-19.21C78.46 37.501 90.97 50.65 92.44 65.086c1.39 13.636-2.938 28.022-16.405 33.481-7.02 2.846-14.396 2.248-18.833-4.52-6.78-10.338-.647-26.74 6.11-35.447 21.086-27.173 60.59-43.303 94.584-37.123M141.101 3.115c4.544 3.976 14.634 13.372 18.644 19.145"
    />
    <path
      stroke="#FFDCD1"
      strokeLinecap="round"
      strokeWidth={4.66}
      d="M159.74 22.26c-5.646 2.138-18.383 7.418-24.157 11.427"
    />
  </svg>
)
